import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

function RunbookStepActionDropdown({ onChange, value }) {
  const runbookStepReducer = useSelector((state) => state.runbookStep);

  return (
    <>
      {runbookStepReducer.actions && (
        <Form.Select onChange={(e) => onChange(e.target.value)} value={value}>
          {runbookStepReducer.actions.map((action, i) => (
            <option value={action.action} key={i}>
              {action.action}
            </option>
          ))}
        </Form.Select>
      )}
    </>
  );
}

export default RunbookStepActionDropdown;
